import Vue from 'vue'
import VueRouter from "vue-router";
import Home from './views/Home.vue'
import Aprovisionnement from './views/Aprovisionnement.vue'
import Params from './views/Params.vue'
import AdminStock from './views/AdminStock.vue'
import stockEnter from './views/stockEnter.vue'
import customerManage from './views/customerManage.vue'
import customerCommande from './views/customerCommande.vue'
import caisseView from './views/caisseView.vue'
import outProductStock from './views/outProductStock.vue'
// import emptyView from './views/emptyView.vue'
import manageInventoryView from './views/manageInventory.vue'
import comptabiliteView from './views/comptabiliteView.vue'
import outMoney from './views/outMoney.vue'
import returnStore from './views/returnStore.vue'
import pertProduit from './views/pertProduit.vue'
import Reduction from './views/reductView.vue'
import StatView from './views/statView.vue'
import Estimation from './views/Estimation.vue'
Vue.use(VueRouter);
const routes = [
  {
    path: "/login",
    name: "loginApp",
    component: () => import("./views/Login"),
    beforeEnter(to, from, next) {
      const user = localStorage.getItem("user-token");
      const admin = localStorage.getItem("admin-token");

      // student
      if (user || admin) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/",
    name: "Dashboard",
    component: () => import("./layouts/Dashboard"),
    beforeEnter(to, from, next) {
      const user = localStorage.getItem("user-token");
      const admin = localStorage.getItem("admin-token");

      // student
      if (user || admin) {
        next();
      } else {
        next("/login");
      }
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/reduction',
        name: 'Reduction',
        component: Reduction
      },
      {
        path: '/approvisionnement',
        name: 'approvisionnement',
        component: Aprovisionnement
      },
      {
        path: '/estimation',
        name: 'estimation',
        component: Estimation
      },
      {
        path: '/stock',
        name: 'stock',
        component: AdminStock
      },
      {
        path: '/parameters',
        name: 'parameters',
        component: Params
      },
      {
        path: '/statistiques',
        name: 'Statistiques',
        component: StatView
      },
      {
        path: '/sortie_argent',
        name: 'sortie_argent',
        component: outMoney
      },
      {
        path: '/entrer',
        name: 'entrer',
        component: stockEnter
      },
      {
        path: '/sortie',
        name: 'sortie',
        component: outProductStock
      },
      {
        path: '/inventaire',
        name: 'inventaire',
        component: manageInventoryView
      },
      {
        path: '/missed',
        name: 'missed',
        component: pertProduit
      },
      {
        path: '/client',
        name: 'client',
        component: customerManage
      },
      {
        path: '/commande',
        name: 'commande',
        component: customerCommande
      },
      {
        path: '/retour',
        name: 'retour',
        component: returnStore
      },
      {
        path: '/caisse',
        name: 'caisse',
        component: caisseView
      },
      {
        path: '/comptabilite',
        name: 'comptabilite',
        component: comptabiliteView
      },
      {
        path: '/documentation',
        name: 'documentation',
        component: () => import('./views/DocumentationView.vue')
      },
      {
        path: '*',
        name: 'notFound',
        redirect: '/'
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;